// extracted by mini-css-extract-plugin
export default {"catItems":"Categor_catItems__UHz39","catNav":"Categor_catNav__7c38f","catItem":"Categor_catItem__sa2Ul","active":"Categor_active__tyHjl"};